const RESOURCE_NAME = '/entri';

export default axios => ({
    getToken() {
        return axios.post(`${RESOURCE_NAME}`);// get - /token
    },
    getConfig(data, params) {
        return axios.post(`${RESOURCE_NAME}/config`, data, {params});
    },
    checkDomain(params) {
        return axios.get(`${RESOURCE_NAME}/verify`, {params});
    },
});